// extracted by mini-css-extract-plugin
export default {"title":"News&EventsView_title__RIS4q","description":"News&EventsView_description__kZPiK"};